import { render, staticRenderFns } from "./SpinnersLoader.vue?vue&type=template&id=88e82566&scoped=true&"
import script from "./SpinnersLoader.vue?vue&type=script&lang=js&"
export * from "./SpinnersLoader.vue?vue&type=script&lang=js&"
import style0 from "./SpinnersLoader.vue?vue&type=style&index=0&id=88e82566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e82566",
  null
  
)

export default component.exports